import { useState, useEffect } from "react";

let cachedData = null;

function useSponsors() {
    const [data, setData] = useState(cachedData);
    const [loading, setLoading] = useState(!cachedData);

    useEffect(() => {
        if (cachedData) return;
        fetch("/config/sponsors.json")
            .then((res) => res.json())
            .then((json) => {
                cachedData = json;
                setData(cachedData);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to load sponsors.json:", err);
                setLoading(false);
            });
    }, []);

    return { data, loading };
}

export default useSponsors;
